<template>
  <header class="hero">
    <div class="hero-content">
      <div class="badge fade-in">2026 科技社区全新推出</div>
      <h1 class="fade-in">在秋意中，<br /><span class="gradient-text">预见未来。</span></h1>
      <p class="subtitle">来秋 (LAIQIU) 科技社区，一个连接全球开发者、艺术家与思想者的先锋阵地。</p>
      <div class="hero-btns">
        <button class="btn-primary">开启探索</button>
        <button class="btn-outline">品牌视频</button>
      </div>
    </div>
    <div class="hero-visual">
      <div class="orb"></div>
      <div class="orb orb-2"></div>
    </div>
  </header>
</template>

<style scoped>
.hero {
  height: 100vh;
  display: flex;
  align-items: center;
  padding: 0 10%;
  position: relative;
}

.hero-content {
  flex: 1;
  z-index: 2;
}

.badge {
  display: inline-block;
  padding: 4px 12px;
  background: rgba(109, 93, 252, 0.2);
  border: 1px solid var(--accent);
  border-radius: 20px;
  font-size: 0.8rem;
  margin-bottom: 20px;
  color: #a29bfe;
}

h1 {
  font-size: 5rem;
  line-height: 1.1;
  margin-bottom: 1.5rem;
}

.gradient-text {
  background: linear-gradient(90deg, #fff, #666);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
}

.subtitle {
  font-size: 1.2rem;
  opacity: 0.6;
  margin-bottom: 3rem;
  max-width: 500px;
}

.hero-btns button {
  padding: 1rem 2.5rem;
  font-size: 1rem;
  margin-right: 1.5rem;
  cursor: pointer;
  transition: 0.3s;
}

.btn-primary {
  background: transparent;
  border: 1px solid #fff;
  color: #fff;
}

.btn-outline {
  background: transparent;
  border: 1px solid #fff;
  color: #fff;
}

.btn-outline:hover,
.btn-primary:hover {
  background: #fff;
  color: #000;
}

.orb {
  position: absolute;
  right: 10%;
  top: 20%;
  width: 400px;
  height: 400px;
  background: radial-gradient(circle, #6d5dfc 0%, transparent 70%);
  filter: blur(60px);
  animation: float 10s infinite alternate;
}

.orb-2 {
  left: 5%;
  top: 60%;
  background: radial-gradient(circle, #3498db 0%, transparent 70%);
  width: 300px;
  height: 300px;
  opacity: 0.4;
}

@keyframes float {
  from {
    transform: translate(0, 0);
  }

  to {
    transform: translate(-50px, 50px);
  }
}

/* 响应式 */
@media (max-width: 768px) {
  h1 {
    font-size: 3rem;
  }

  .hero {
    padding: 0 5%;
  }
}
</style>